module.exports = __webpack_public_path__ + "img/concept-micro-frontends.6118762b.svg";